import { render, staticRenderFns } from "./authorization-selector-btn.vue?vue&type=template&id=2043a749&scoped=true&"
import script from "./authorization-selector-btn.vue?vue&type=script&lang=js&"
export * from "./authorization-selector-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043a749",
  null
  
)

export default component.exports